import { useEffect, useState } from "react";

import { fetchTasks } from "@/services";
import type { Task } from "@/types";

export function useTasks(assigneeId?: string) {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    fetchTasks(assigneeId)
      .then((data) => {
        if (!cancelled) {
          setTasks(data);
          setError(null);
        }
      })
      .catch((error_: unknown) => {
        if (!cancelled) {
          setError(String(error_));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [assigneeId]);

  return { tasks, loading, error };
}
